import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import { useHandleLinkClick } from '../../../hooks/useHandleLinkClick';


export default function CTACompanies() {
    const handleLinkClick = useHandleLinkClick();

    const initStrings = {
        content: stringsTranslate(appWords.contact_with_knaek_on)
    }

    return (
        <div className="section section-button-homepage  mt-5 p-5"  id='cta'>
            <div className="container">
                <div className="row">
                    <div className="col-12 text-left d-flex align-items-center justify-content-center mt-2">
                        <a className={"cursor-pointer"} onClick={()=> handleLinkClick("/contact")}>
                            <div className="text-center section-button-homepage-content">
                                <div className="text-center section-button-homepage-content cursor-pointer">
                                <svg width="74" height="74" viewBox="0 0 32 32" className="svg-white text-center">
                                    <path d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm7,16.5-4.3,4.3-.5.2-.4-.2a.7.7,0,0,1-.01-.99l.01-.01,3.1-3.1H9.5a.7.7,0,0,1,0-1.4H20.9l-3.1-3.1a.7.7,0,0,1-.01-.99l.01-.01a.8.8,0,0,1,.9,0L23,15.5a.7.7,0,0,1,.01.99Z"></path>
                                </svg>
                                <h1 className="text-white text-center ml-3 pt-2">{initStrings.content}</h1>
                            </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
